import Icon from '@/components/ui/AppIcon';

interface BenefitCardProps {
  icon: string;
  title: string;
  description: string;
}

export default function BenefitCard({ icon, title, description }: BenefitCardProps) {
  return (
    <div className="flex items-start space-x-4 p-6 bg-card rounded-lg border border-border hover:shadow-md transition-all duration-300">
      <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center">
        <Icon name={icon as any} size={24} variant="outline" className="text-accent" />
      </div>
      <div>
        <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
          {title}
        </h3>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
    </div>
  );
}